import { InjectionToken } from '@angular/core';
import { EntryFormattingPort } from "../ports/entry-formatting.port";

export const ENTRY_FORMATTING_PORT = new InjectionToken<EntryFormattingPort>('ENTRY_FORMATTING_PORT');
